import styled from '@emotion/styled';
import { remCalc, font, palette } from '../../css';
import { StyledButton } from '../Button/Button.css';

const StyledSubscribe = styled('div')(() => ({
    position: 'relative',
    width: remCalc(220),
    textAlign: 'center',
    color: palette('white'),
    cursor: 'pointer',

    [StyledButton]: {
        fontWeight: font.weight.medium,
        paddingTop: remCalc(15),
        paddingBottom: remCalc(15),
    },
}));

export { StyledSubscribe };
